import { Box, Typography } from "@mui/material";

const StatItem: React.FC<{
  label: string;
  value: string | number;
}> = ({ label, value }) => {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2" fontWeight="medium">
        {value}
      </Typography>
    </Box>
  );
};

export default StatItem;
